/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var AddressDisplayView = require('common/views/AddressDisplayView');

var tmplCorpFinRegRegistrantSectionView = require('../templates/CorpFinRegRegistrantSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinRegRegistrantSectionView,

  className: 'corp-fin-reg-registrant-section-view form-horizontal form-static m-b-lg',

  ui: {
    addressContainer: '.address-container'
  },

  regions: {
    addressContainer: '@ui.addressContainer'
  },

  onBeforeShow: function() {
    var issuerAddress = this.model.get('issuerAddress');
    this.showChildView('addressContainer', new AddressDisplayView({ model: new Backbone.Model(issuerAddress) }));
  }
});
